import React from 'react';
import { createRoot } from 'react-dom/client';
import { LicenseInfo } from '@mui/x-license';
import Root from './containers/Root';
import reportWebVitals from './core/reportWebVitals';
import './core/styles/dirtyFields.css';

const container = document.getElementById('root');
const root = createRoot(container!);
LicenseInfo.setLicenseKey('f7a2648fe9c190bb408f38ffb21191a1Tz05NTMwMyxFPTE3NTQwNjIxMTQwMDAsUz1wcmVtaXVtLExNPXBlcnBldHVhbCxLVj0y');
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// eslint-disable-next-line no-console
reportWebVitals(console.log);
